import React, { useRef, useContext, useEffect, useState } from "react";
import "./App.scss";
import SideNav from "./components/SideNav";
import PageRouter from "./router/PageRouter";
import ScrollToTop from "./router/ScrollToTop";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ContextProvider from "./context/ContextProvider";
import StartScreen from "./pages/StartScreen";
import ReactGA from "react-ga";
import Toast from "./components/Toast";
import Player from "./components/Player";
import { PlaylistStore } from "./context/ContextProvider";
import AlbumPage from "./pages/AlbumPage";
import CreatePlaylist from "./components/CreatePlaylistModal";

const TRACKING_ID = "G-BC9YJSXES5";
ReactGA.initialize(TRACKING_ID);

ReactGA.exception({
  description: "An error ocurred",
  fatal: true,
});

const Screen = () => {
  const [signedIn, setSignedIn] = useState(false);
  const contextStore = useContext(PlaylistStore);
  const { accessToken, errorMessage } = contextStore.state;
  useEffect(() => {
    if (accessToken) {
      setSignedIn(true);
    }
    // console.log(accessToken)
  }, [accessToken]);

  return (
    <div className="screen">
      <Switch>
        <Route exact path="/">
          <StartScreen />
        </Route>
        <Route path="/app">
          <MainApp contextStore={contextStore} />
        </Route>
        <Route path="/error-page">
          <div>
            <h1 style={{ fontSize: "60px" }}>{errorMessage}</h1>
          </div>
        </Route>
      </Switch>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ContextProvider>
        <Screen />
      </ContextProvider>
    </Router>
  );
}

export default App;

const MainApp = ({ contextStore }) => {
  const { selectedPlaylist, modalOpen, navOpen } = contextStore.state;

  const navLength = navOpen ? 1 : 0;

  const pageWrap = useRef(null);
  return (
    <div className="App">
      <CreatePlaylist modalOpen={modalOpen} />
      <div className="section-container">
        <div className="nav-section" style={{ flex: `${navLength} 3`, borderRight: navOpen ? "solid 2px rgb(236, 236, 236)" : "none" }}>
          {navOpen ? <SideNav /> : null}
        </div>
        <div ref={pageWrap} className="pages-section">
          {/* {selectedPlaylist ? <AlbumPage /> : null} */}
          <Toast />
          <ScrollToTop pageWrap={pageWrap} />
          <PageRouter />
        </div>
      </div>
      <div className="player-section">
        <Player />
      </div>
    </div>
  );
};
